import { c as _c } from "react/compiler-runtime";
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';
import { ChangeEvent, ComponentProps, PropsWithChildren, useEffect, useRef, useState } from 'react';
type ViverseTextareaProps = PropsWithChildren<ComponentProps<typeof Textarea>> & {
  showMaxLength?: boolean;
  containerClassName?: string;
};
function ViverseTextarea(t0) {
  const $ = _c(30);
  let children;
  let className;
  let containerClassName;
  let maxLength;
  let onChange;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      children,
      maxLength,
      showMaxLength: t1,
      onChange,
      containerClassName,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = containerClassName;
    $[4] = maxLength;
    $[5] = onChange;
    $[6] = props;
    $[7] = t1;
  } else {
    children = $[1];
    className = $[2];
    containerClassName = $[3];
    maxLength = $[4];
    onChange = $[5];
    props = $[6];
    t1 = $[7];
  }
  const showMaxLength = t1 === undefined ? true : t1;
  const [valueLength, setValueLengh] = useState(0);
  const defaultValue = useRef(typeof props.value === "string" ? props.value : "");
  let t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (defaultValue.current) {
        setValueLengh(defaultValue.current.length);
      }
    };
    t3 = [];
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== onChange) {
    t4 = e => {
      onChange?.(e);
      setValueLengh(e.target.value.length);
    };
    $[10] = onChange;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleChange = t4;
  let t5;
  if ($[12] !== containerClassName) {
    t5 = cn("bg-vive-popup border-vive-primary-70 focus-within:border-vive-border-focus! hover:border-vive-brand-50 flex flex-1 items-center rounded-md border-2 transition-all duration-300", containerClassName);
    $[12] = containerClassName;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== className) {
    t6 = cn("bg-vive-popup resize-none rounded-sm border-none text-white", className);
    $[14] = className;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== children || $[17] !== handleChange || $[18] !== maxLength || $[19] !== props || $[20] !== t6) {
    t7 = <Textarea className={t6} onChange={handleChange} maxLength={maxLength} {...props}>{children}</Textarea>;
    $[16] = children;
    $[17] = handleChange;
    $[18] = maxLength;
    $[19] = props;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== maxLength || $[23] !== showMaxLength || $[24] !== valueLength) {
    t8 = showMaxLength && <div className="h-full w-max px-3 py-1 text-nowrap"><span className="caption text-vive-primary-40">{valueLength} / {maxLength}</span></div>;
    $[22] = maxLength;
    $[23] = showMaxLength;
    $[24] = valueLength;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t5 || $[27] !== t7 || $[28] !== t8) {
    t9 = <div className="box-border flex items-center"><div className={t5}>{t7}{t8}</div></div>;
    $[26] = t5;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  return t9;
}
export default ViverseTextarea;